import { useEffect } from 'react';
import { useOLMap } from './MapContext';
import ScaleLine from 'ol/control/ScaleLine';
export const MAPSCALE_TARGET = 'map-scale';
export const MapScale = () => {
    const map = useOLMap();
    useEffect(() => {
        if (!map)
            return;
        const scaleLine = new ScaleLine({
            units: 'metric',
            minWidth: 120,
            bar: true,
            target: MAPSCALE_TARGET,
        });
        map.addControl(scaleLine);
    }, [map]);
    return null;
};
//# sourceMappingURL=MapScale.js.map